import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { useAccess } from 'contexts/AccessContext'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { Banner, BannerIcon, BannerText } from './styled'

const prefix = 'monitoring.course.statistics.rolesAccessBanner'

/**
 * Banner informativo ABAC: participantes visibles según alcance del rol (no admin).
 */
export const RolesAccessBanner = () => {
  const { isAdmin } = useAccess()
  const t = useTranslationRankmi({ prefix })

  if (isAdmin()) return null

  return (
    <Banner role="status">
      <BannerIcon aria-hidden>
        <FontAwesomeIcon icon={faInfoCircle} />
      </BannerIcon>
      <BannerText>{t('message')}</BannerText>
    </Banner>
  )
}

export default RolesAccessBanner
